import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AboutUsService } from '../../services/about-us.service';
import { AboutUsModel } from '../../models/about-us.model';
import { TeamService } from '../../services/team.service';
import { TeamModel } from '../../models/team.model';
@Component({
  selector: 'app-page-aboutus-two',
  templateUrl: './page-aboutus-two.component.html',
  styleUrls: ['./page-aboutus-two.component.css']
})

/**
 * Aboutus Two Component
 */
export class PageAboutusTwoComponent implements OnInit {
  navClass = 'nav-light';
  currentLang = localStorage.getItem('lang') || 'ar';
      // Set Topbar Option
  Menuoption = 'center';
  Settingicon = true
  constructor(private modalService: NgbModal,private aboutUsService:AboutUsService,private TeamService:TeamService,) { }
  about:AboutUsModel []=[]
temamembers: TeamModel[] = [];

  ngOnInit(): void {
    this.aboutUsService.getAll()
    .subscribe(result=>{
      this.about = result;
    })
     this.TeamService.getTeam()
    .subscribe(result =>{
      this.temamembers = result;
    })
  }

  num: number = 0;
  option = {
    startVal: this.num,
    useEasing: true,
    duration: 1,
    decimalPlaces: 0,
  };

  /**
  * Open modal for show the video
  * @param content content of modal
  */
  openWindowCustomClass(content) {
    this.modalService.open(content, { windowClass: 'dark-modal', size: 'lg', centered: true });
  }

}
